<template>
  <!-- 登录 -->
  <div class="login">
    <!-- logo以及背景图 -->
    <div class="logo" v-if="platformData.platformAdminLogo">
      <img :src="platformData.platformAdminLogo.imagePath" alt="" />
    </div>
    <div class="login-content">
      <div
        class="cover"
        v-if="platformData.platformAdminBackground"
        :style="{
          backgroundImage:
            'url(' + platformData.platformAdminBackground.imagePath + ')',
        }"
      ></div>
      <!-- 表单模块 -->
      <div class="login-form" v-if="prohibit">
        <div class="title">
          {{ platformData.platformAdminName }}
        </div>
        <div class="from">
          <!-- 账号 -->
          <div :class="['from-item', tips.username.hiddle ? 'err-item' : '']">
            <span><img src="../../assets/images/name.png" alt="" /></span>
            <input
              type="text"
              :placeholder="$t('pages.login.text2')"
              @blur="blur('user')"
              v-model="ruleForm.username"
            />
            <span
              class="border-bottom"
              :style="{
                backgroundColor: tips.username.hiddle ? '#f56c6c' : '#1f5bcc',
              }"
            ></span>
            <div class="tips" v-if="tips.username.hiddle">
              {{ tips.username.tips }}
            </div>
          </div>
          <!-- 密码 -->
          <div :class="['from-item', tips.pwd.hiddle ? 'err-item' : '']">
            <span><img src="../../assets/images/pwd.png" alt="" /></span>
            <input
              type="password"
              :placeholder="$t('pages.login.text3')"
              v-model="ruleForm.password"
              @blur="blur('pwd')"
              @keypress="testCapsLock"
            />
            <div class="case-detection" v-if="caseState">大写锁定已打开</div>
            <span
              class="border-bottom"
              :style="{
                backgroundColor: tips.pwd.hiddle ? '#f56c6c' : '#1f5bcc',
              }"
            ></span>
            <div class="tips" v-if="tips.pwd.hiddle">
              {{ tips.pwd.tips }}
            </div>
          </div>
          <!-- 验证码 -->
          <div class="code-item">
            <div
              :class="[
                'code-input',
                'from-item',
                tips.code.hiddle ? 'err-item' : '',
              ]"
              style="margin-bottom: 0"
            >
              <input
                type="text"
                :placeholder="$t('pages.login.text4')"
                v-model="ruleForm.captcha"
                style="margin: 0"
                @blur="blur('code')"
              />
              <span
                class="border-bottom"
                :style="{
                  backgroundColor: tips.code.hiddle ? '#f56c6c' : '#1f5bcc',
                }"
              ></span>
              <div class="tips" v-if="tips.code.hiddle">
                {{ tips.code.tips }}
              </div>
            </div>
            <div class="code-image" @click="getCaptcha">
              <img :src="yzmUrl" alt="获取失败" />
            </div>
          </div>
          <!-- 记住密码 忘记密码 -->
          <div class="operation-item">
            <div>
              <el-checkbox v-model="rememberPassword">{{
                $t("pages.login.text5")
              }}</el-checkbox>
            </div>
            <div @click="gotoForgetPassword" class="forget-password">
              {{ $t("pages.login.text6") }}?
            </div>
          </div>
          <!-- 提交按钮 -->
          <el-button class="submit" type="primary" @click="submit">{{
            $t("pages.login.text7")
          }}</el-button>
        </div>
      </div>
      <!-- 平台过期失效 -->
      <div class="login-form" v-else>
        <div class="prohibit">{{ $t("pages.login.text9") }}</div>
      </div>
    </div>
    <!-- 底部备案 -->
	<!--
    <div class="keep-on-record">
      ©Copy Right 2018-2022
      <a href="https://beian.miit.gov.cn/#/Integrated/index">deebike.com</a>
      {{ $t("pages.login.text10") }}
    </div>
	-->
  </div>
</template>

<script>
import { mapState, mapMutations, mapActions } from "vuex";
export default {
  data() {
    return {
      prohibit: false,
      // 输入验证提示
      tips: {
        username: {
          tips: this.$t("pages.login.text2"),
          hiddle: false,
          verification: false,
        },
        pwd: {
          tips: this.$t("pages.login.text3"),
          hiddle: false,
          verification: false,
        },
        code: {
          tips: this.$t("pages.login.text4"),
          hiddle: false,
          verification: false,
        },
      },
      rememberPassword: false,
      yzmUrl: null,
      ruleForm: {
        captcha: null, //验证码
        checkKey: null, // 验证码key
        customerId: null, // 平台方id
        password: null, // 密码
        username: null, // 账号
      },
      caseState: false,
    };
  },
  computed: {
    ...mapState(["platformData"]),
  },
  created() {
    this.getCaptcha();
    this.getInfoByDomain();

    let stopTime = this.platformData.serveStopTime;

    if (Date.parse(new Date()) > Date.parse(new Date(stopTime))) {
      this.prohibit = false;
    } else {
      if (this.platformData.status == 1) {
        this.prohibit = false;
      } else {
        this.prohibit = true;
      }
    }
  },
  mounted() {
    //保存cookie以及读取cookie，记住密码功能
    if (this.getCookie("username") && this.getCookie("password")) {
      this.ruleForm.username = this.getCookie("username");
      this.ruleForm.password = this.getCookie("password");
    }
    window.addEventListener("keydown", this.handleKeyDown);
  },
  destroyed() {
    window.removeEventListener("keydown", this.handleKeyDown, false); //false阻止默认事件
  },
  methods: {
    ...mapActions(["getInfoByDomain"]),
    ...mapMutations(["setNewRouter", "clearNewRouter"]),
    // enter 触发
    handleKeyDown(e) {
      let key = null;
      if (window.event === undefined) {
        key = e.keyCode;
      } else {
        key = window.event.keyCode;
      }
      if (key === 13) {
        this.submit();
      }
    },
    testCapsLock(e) {
      var valueCapsLock = e.keyCode ? e.keyCode : e.which; // 按键
      var valueShift = e.shiftKey
        ? e.shiftKey
        : valueCapsLock == 16
        ? true
        : false; // shift键是否按住
      if (
        (valueCapsLock >= 65 && valueCapsLock <= 90 && !valueShift) || // 输入了大写字母，并且shift键没有按住，说明Caps Lock打开
        (valueCapsLock >= 97 && valueCapsLock <= 122 && valueShift)
      ) {
        // 输入了小写字母，并且按住 shift键，说明Caps Lock打开
        this.caseState = true;
      } else {
        this.caseState = false;
      }
    },
    //设置cookie
    setCookie(name, value, day) {
      var date = new Date();
      date.setDate(date.getDate() + day);
      document.cookie = name + "=" + value + ";expires=" + date;
    },
    // 获取cookie
    getCookie(name) {
      var reg = RegExp(name + "=([^;]+)");
      var arr = document.cookie.match(reg);
      if (arr) {
        return arr[1];
      } else {
        return "";
      }
    },
    // 输入框输入验证
    blur(e) {
      if (e == "user") {
        if (!this.ruleForm.username) {
          this.tips.username.tips = this.$t("pages.login.text2");
          this.tips.username.hiddle = true;
          this.tips.username.verification = false;
        } else if (
          this.ruleForm.username.lenght > 10 ||
          this.ruleForm.username.length < 2
        ) {
          this.tips.username.tips = this.$t("pages.login.text11");
          this.tips.username.hiddle = true;
          this.tips.username.verification = false;
        } else if (this.ruleForm.username.indexOf(" ") != -1) {
          this.tips.username.tips = this.$t("config.text23");
          this.tips.username.hiddle = true;
          this.tips.username.verification = false;
        } else {
          this.tips.username.tips = "";
          this.tips.username.hiddle = false;
          this.tips.username.verification = true;
        }
      }
      if (e == "pwd") {
        if (!this.ruleForm.password) {
          this.tips.pwd.tips = this.$t("pages.login.text3");
          this.tips.pwd.hiddle = true;
          this.tips.pwd.verification = false;
        } else if (
          this.ruleForm.password.length > 18 ||
          this.ruleForm.password.length < 6
        ) {
          this.tips.pwd.tips = this.$t("pages.login.text8");
          this.tips.pwd.hiddle = true;
          this.tips.pwd.verification = false;
        } else {
          this.tips.pwd.tips = "";
          this.tips.pwd.hiddle = false;
          this.tips.pwd.verification = true;
        }
      }
      if (e == "code") {
        if (!this.ruleForm.captcha) {
          this.tips.code.tips = this.$t("pages.login.text4");
          this.tips.code.hiddle = true;
          this.tips.code.verification = false;
        } else {
          this.tips.code.tips = "";
          this.tips.code.hiddle = false;
          this.tips.code.verification = true;
        }
      }
    },
    //忘记密码
    gotoForgetPassword() {
      this.$router.push("/forgetPassword");
    },
    // 获取验证码
    getCaptcha() {
      this.ruleForm.checkKey = new Date().getTime();
      this.request.randomImage({key:this.ruleForm.checkKey}).then((res) => {
        this.yzmUrl = res.data;
      });
    },
    // 登录
    submit() {
      let that = this;
      let isOk = true;
      this.blur("user");
      this.blur("pwd");
      this.blur("code");
      for (let i in this.tips) {
        if (!this.tips[i].verification) {
          isOk = false;
        }
      }
      if (!isOk) {
        return;
      }
      if (this.rememberPassword) {
        this.setCookie("username", this.ruleForm.username, 7); //保存帐号到cookie，有效期7天
        this.setCookie("password", this.ruleForm.password, 7); //保存密码到cookie，有效期7天
      } else {
        this.setCookie("username", "", -1); //保存帐号到cookie，有效期7天
        this.setCookie("password", "", -1); //保存密码到cookie，有效期7天
      }
      this.ruleForm.customerId = this.platformData.id;
      this.request
        .login(this.ruleForm)
        .then((res) => {
          localStorage.setItem("userInfo", JSON.stringify(res.data.userInfo)); //用户信息
          localStorage.setItem("token", res.data.token); //token
          localStorage.setItem("menuTree", JSON.stringify(res.data.menuTree)); //页面权限
          localStorage.setItem(
            "buttonPerms",
            JSON.stringify(res.data.buttonPerms)
          ); //按钮权限
          this.clearNewRouter();
          this.$message.success(that.$t("pages.login.text12"));
          this.setNewRouter({
            routerArr: res.data.menuTree,
            platformCode: this.platformData.platformCode,
          });
          setTimeout(() => {
            this.$router.push({ path: "/" + res.data.menuTree[0].path });
          }, 1000);
        })
        .catch((err) => {
          this.$message.error(err.msg);
        });
    },
  },
};
</script>

<style scoped>
.login {
  width: 100%;
  height: 100vh;
  background-color: #fff;
  display: flex;
  flex-direction: column;
  justify-content: center;
}
.logo {
  margin-left: 32px;
  margin-bottom: 20px;
  margin-top: -100px;
}
.logo img {
  width: 150px;
}
.login-content {
  display: flex;
  height: 60%;
}
.keep-on-record {
  font-size: 12px;
  font-family: SourceHanSansCN-Regular;
  line-height: 33px;
  color: #455060;
  position: fixed;
  bottom: 25px;
  left: 0;
  right: 0;
  margin: auto;
  letter-spacing: 1px;
  text-align: center;
}
.keep-on-record a {
  color: #1f5bcc;
}
.cover {
  width: calc(1223 / 1920 * 100%);
  height: 100%;
  background-image: url("../../assets/images/cover.png");
  background-position: center;
  background-size: cover;
  background-repeat: no-repeat;
}
.cover img {
  width: 100%;
  display: block;
}
.login-form {
  flex: 1;
  display: flex;
  flex-direction: column;
  background-color: rgba(229, 238, 252, 0.4);
  justify-content: center;
}
.title {
  text-align: center;
  font-size: 26px;
  font-family: PingFang SC;
  font-weight: 500;
  color: #000000;
  margin: 50px 0;
}
.from {
  display: flex;
  flex-direction: column;
  width: 370px;
  margin: 0 auto;
}
.from-item {
  display: flex;
  align-items: center;
  padding: 5px 10px;
  box-sizing: border-box;
  border-bottom: 1px solid #dfdfdf;
  box-sizing: border-box;
  margin-bottom: 30px;
  position: relative;
}
.code-input {
  width: 70%;
}

.tips {
  position: absolute;
  color: #f56c6c;
  left: 0px;
  bottom: -25px;
  font-size: 12px;
  transition: all 0.3s;
  animation-name: err;
  animation-duration: 0.3s;
}

@keyframes err {
  from {
    bottom: -18px;
  }
  to {
    bottom: -25px;
  }
}

.from-item input {
  border: none;
  flex: 1;
  outline: none;
  margin-left: 14px;
  background-color: transparent;
}
.from-item span {
  width: 14px;
  display: flex;
  justify-content: center;
  align-items: center;
}
.from-item span img {
  width: 100%;
  display: block;
}
.from-item .border-bottom {
  content: " ";
  position: absolute;
  display: block;
  height: 1px;
  bottom: -1px;
  width: 0;
  left: 0;
  right: 0;
  margin: auto;
  background-color: #1f5bcc;
  transition: all 0.25s;
}
.from-item:focus-within .border-bottom {
  width: 100%;
}
.code-item {
  display: flex;
  margin-bottom: 30px;
}
.code-image {
  margin-left: 20px;
  border-radius: 4px;
  overflow: hidden;
}
.code-image img {
  height: 100%;
  display: block;
}
.operation-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 30px;
  width: 100%;
}
.forget-password {
  color: #455060;
  cursor: pointer;
  width: 40%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  margin-left: 20px;
}
.submit {
  margin-bottom: 50px;
}
.prohibit {
  text-align: center;
}
.case-detection {
  font-size: 12px;
  position: absolute;
  right: 0;
  bottom: 3px;
  padding: 4px 8px;
  border-radius: 5px;
  background-color: #d8e6ff;
}
</style>
